import {
  Autocomplete,
  Checkbox,
  createTheme,
  Modal,
  MultiSelect,
  NativeSelect,
  NumberInput,
  Select,
  TagsInput,
  Textarea,
  TextInput,
} from "@mantine/core";
import { DateInput, MonthPickerInput, YearPickerInput } from "@mantine/dates";

import styles from "./styles/theme.module.scss";

const theme = createTheme({
  components: {
    Select: Select.extend({
      classNames: {
        option: styles.selectOption,
        label: styles.inputLabel,
        input: styles.input,
        required: styles.required,
        wrapper: styles.inputWrapper,
        description: styles.inputDescription,
      },
    }),
    Autocomplete: Autocomplete.extend({
      classNames: {
        option: styles.selectOption,
      },
    }),
    TextInput: TextInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        required: styles.required,
        wrapper: styles.inputWrapper,
        description: styles.inputDescription,
      },
    }),
    DateInput: DateInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        day: styles.dateOption,
        required: styles.required,
        wrapper: styles.inputWrapper,
        description: styles.inputDescription,
      },
      defaultProps: {
        defaultDate: new Date(),
      },
    }),
    MonthPickerInput: MonthPickerInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        required: styles.required,
        section: styles.dateInputSection,
        monthsListControl: styles.dateOption,
        wrapper: styles.inputWrapper,
        description: styles.inputDescription,
      },
      defaultProps: {
        defaultDate: new Date(),
      },
    }),
    YearPickerInput: YearPickerInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        required: styles.required,
        section: styles.dateInputSection,
        yearsListControl: styles.dateOption,
        wrapper: styles.inputWrapper,
      },
      defaultProps: {
        defaultDate: new Date(),
      },
    }),
    NativeSelect: NativeSelect.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        required: styles.required,
        wrapper: styles.inputWrapper,
        description: styles.inputDescription,
      },
    }),
    Textarea: Textarea.extend({
      classNames: {
        input: styles.textarea,
        label: styles.inputLabel,
        required: styles.required,
        wrapper: styles.inputWrapper,
        description: styles.inputDescription,
      },
    }),
    NumberInput: NumberInput.extend({
      classNames: {
        input: styles.input,
        label: styles.inputLabel,
        control: styles.numberInputControl,
        required: styles.required,
        wrapper: styles.inputWrapper,
        description: styles.inputDescription,
      },
    }),
    Checkbox: Checkbox.extend({
      classNames: {
        input: styles.checkboxInput,
        icon: styles.unusedIcon,
        inner: styles.checkboxInner,
      },
    }),
    MultiSelect: MultiSelect.extend({
      classNames: {
        input: styles.multiSelectInput,
        label: styles.inputLabel,
        pill: styles.multiSelectPill,
        inputField: styles.multiSelectInputField,
        dropdown: styles.multiSelectDropdown,
        option: styles.multiSelectOption,
        options: styles.multiSelectOptions,
        wrapper: styles.inputWrapper,
        description: styles.inputDescription,
      },
    }),
    TagsInput: TagsInput.extend({
      classNames: {
        input: styles.multiSelectInput,
        label: styles.inputLabel,
        pill: styles.multiSelectPill,
        inputField: styles.multiSelectInputField,
        wrapper: styles.inputWrapper,
        description: styles.inputDescription,
      },
    }),
    Modal: Modal.extend({
      classNames: {
        content: styles.modalWindow,
      },
    }),
  },
});

export default theme;
